import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PaymentService } from '../shared/services/payment.service';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { Subject, Subscription, of } from 'rxjs';
import { Utils } from '../shared/utils/utils';
declare const swal: any;

@Component({
  selector: 'app-send-payment',
  templateUrl: './send-payment.component.html',
  styleUrls: ['./send-payment.component.css']
})
export class SendPaymentComponent implements OnInit {

  paymentForm: FormGroup;
  busy: Subscription;
  isLoading = false;
  isSearching = false;

  // Autocomplete
  searchQuery = '';
  clientResults: any[] = [];
  selectedClient: any = null;
  showDropdown = false;
  searchSubject = new Subject<string>();

  constructor(
    private fb: FormBuilder,
    private paymentService: PaymentService
  ) {}

  ngOnInit(): void {
    this.paymentForm = this.fb.group({
      type:    ['one_shot', Validators.required],
      montant: [null, [Validators.required, Validators.min(1)]],
    });

    // Autocomplete
    this.searchSubject.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      switchMap(query => {
        if (query.length < 3) {
          this.clientResults = [];
          this.showDropdown = false;
          this.isSearching = false;
          return of([]);
        }
        this.isSearching = true;
        return this.paymentService.searchClients(query);
      })
    ).subscribe({
      next: (clients) => {
        this.isSearching = false;
        this.clientResults = clients;
        this.showDropdown = clients.length > 0;
      },
      error: () => {
        this.isSearching = false;
        this.clientResults = [];
        this.showDropdown = false;
      }
    });
  }

  get isSubscription(): boolean {
    return this.paymentForm.get('type')?.value === 'subscription';
  }

  onSearchChange(query: string): void {
    this.selectedClient = null;
    this.searchQuery = query;
    if (query.length >= 3) {
      this.isSearching = true;
    } else {
      this.isSearching = false;
      this.showDropdown = false;
      this.clientResults = [];
    }
    this.searchSubject.next(query);
  }

  selectClient(client: any): void {
    this.selectedClient = client;
    this.searchQuery = client.company_name;
    this.showDropdown = false;
    this.clientResults = [];
    this.isSearching = false;
  }

  clearClient(): void {
    this.selectedClient = null;
    this.searchQuery = '';
    this.clientResults = [];
    this.showDropdown = false;
    this.isSearching = false;
  }

  onSubmit(): void {
    if (this.paymentForm.invalid || !this.selectedClient) {
      Utils.sweetAlert('error', 'Erreur', 'Veuillez remplir tous les champs et sélectionner un client.');
      return;
    }

    this.isLoading = true;

    const payload = {
      client_id: this.selectedClient.id,
      type:      this.paymentForm.value.type,
      montant:   this.paymentForm.value.montant,
    };

    this.busy = this.paymentService.sendPaymentLink(payload).subscribe({
      next: () => {
        this.isLoading = false;
        swal(
          'Succès',
          `Lien de paiement envoyé avec succès à ${this.selectedClient.email}`,
          'success'
        ).then(() => {
          window.location.reload();
        });
      },
      error: (err) => {
        this.isLoading = false;
        if (err.status === 422) {
          Utils.sweetAlert('error', 'Erreur de validation', 'Vérifiez les informations saisies.');
        } else if (err.status === 500) {
          Utils.sweetAlert('error', 'Erreur serveur', 'Une erreur est survenue. Veuillez réessayer.');
        } else {
          Utils.sweetAlert('error', 'Erreur', 'Impossible d\'envoyer le lien de paiement.');
        }
      }
    });
  }
}